import {Injectable} from '@angular/core';
import {NeqHttpClient as HttpClient} from '@sharedrest/http-client.config';
import {
  DomainRightNutrientFilterDto,
  DomainRightPredictionModelFilterDto,
  DomainRightReferenceFilterDto,
  ReportDto,
  RestResponse
} from '@sharedrest/data.restservice';
import { environment } from '@sharedenvironment';

export class JobTaskResponse {
  status?: JobResponseStatus;
  reportSuccess?: string;
  reportError?: string;
  countTotal?: number;
  countSuccess?: number;
  countFailed?: number;
}

export type JobResponseStatus = 'OK' | 'FAILED';

@Injectable()
export class CustomDataServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /entities/{entityCode}/raw_materials/{id}/report
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.entitiesRawMaterialsReportGetReport
   */
  entitiesRawMaterialsReportGetReport(entityCode: string, id: string, arg1: ReportDto): RestResponse<any> {
    return this.httpClient.request({
      method: 'DOWNLOAD',
      url: uriEncoding`entities/${entityCode}/raw_materials/${id}/report`,
      responseType: 'blob',
      downloadMediaType: 'application/pdf',
      data: arg1
    });
  }

  getNutrientTechnicalDoc(filename: string): RestResponse<any> {
    return this.httpClient.request({
      method: 'DOWNLOAD',
      url: uriEncoding`nutrients/technical-doc?filename=${filename}`,
      responseType: 'blob',
      downloadMediaType: 'application/octet-stream'
    });
  }

  getPredictionModelTechnicalDoc(filename: string): RestResponse<any> {
    return this.httpClient.request({
      method: 'DOWNLOAD',
      url: uriEncoding`prediction_models/technical-doc?filename=${filename}`,
      responseType: 'blob',
      downloadMediaType: 'application/octet-stream'
    });
  }


  exportDomainNutrientRight(arg0: DomainRightNutrientFilterDto): RestResponse<any> {
    return this.httpClient.request({
      method: 'DOWNLOAD',
      url: uriEncoding`rights/nutrients`,
      data: arg0,
      responseType: 'blob',
      downloadMediaType: 'application/octet-stream'
    });
  }

  exportDomainReferenceRight(arg0: DomainRightReferenceFilterDto): RestResponse<any> {
    return this.httpClient.request({
      method: 'DOWNLOAD',
      url: uriEncoding`rights/references`,
      data: arg0,
      responseType: 'blob',
      downloadMediaType: 'application/octet-stream'
    });
  }

  exportDomainPredictionModelRight(arg0: DomainRightPredictionModelFilterDto): RestResponse<any> {
    return this.httpClient.request({
      method: 'DOWNLOAD',
      url: uriEncoding`rights/prediction_models`,
      data: arg0,
      responseType: 'blob',
      downloadMediaType: 'application/octet-stream'
    });
  }
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = environment.data.baseUrl;
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}
